@if (sermonEdit === undefined) {
  <div>
    <form [formGroup]="filterForm" class="zwi-flex-start zwi-block-section--horizontal">
      <mat-form-field appearance="fill">
        <mat-label>Book</mat-label>
        <mat-select formControlName="book">
          @for (b of books; track b) {
            <mat-option [value]="b">{{ b }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Speaker</mat-label>
        <mat-select formControlName="speaker">
          @for (s of speakers; track s) {
            <mat-option [value]="s.id">{{s.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Series</mat-label>
        <mat-select formControlName="series">
          @for (s of series; track s) {
            <mat-option [value]="s.id">{{s.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (hasFilters()) {
        <button (click)="removeFilters()" mat-button color="primary" class="zwi-button--horizontal">Clear Filters</button>
      }
    </form>
  </div>
  <mat-list>
    @for (s of filteredSermons; track s) {
      <zwi-sermon-editor [sermon]="s" (sermonDelete)="deleteSermon($event)" (sermonEdit)="editSermon($event)"></zwi-sermon-editor>
    }
  </mat-list>
} @else {
  <div class="zwi-section">
    <div class="zwi-flex-center">
      <button (click)="clearSermon()" mat-icon-button>
        <mat-icon>arrow_back</mat-icon>
      </button>
      <zwi-headline>Sermon form</zwi-headline>
    </div>
    <div class="zwi-flex-start">
      <div class="zwi-spacer"></div>
      <button mat-raised-button color="primary" (click)="save()" [disabled]="!isFormValid()">Save changes
      </button>
    </div>
    <zwi-upload-form [series]="series" [speakers]="speakers" [sermonInfo]="sermonEdit?.sermonInfo"></zwi-upload-form>
  </div>
}

<!--<zwi-sermon-list [sermons]="sermons"></zwi-sermon-list>-->
